import { gql } from 'types/__generated__/gql';

const KEY_CURRICULUM_PROGRESS_QUERY = gql(/* GraphQL */ `
  query getCurriculumProgressReport($where: KeyReportWhereInput!) {
    keyCurriculumProgressReport(where: $where) {
      curriculumProgressPercentage
    }
  }
`);

export default KEY_CURRICULUM_PROGRESS_QUERY;
